import { render, staticRenderFns } from "./PartnerWithdrawalBatch.vue?vue&type=template&id=4f2c2f76&scoped=true&"
import script from "./PartnerWithdrawalBatch.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawalBatch.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWithdrawalBatch.vue?vue&type=style&index=0&id=4f2c2f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c2f76",
  null
  
)

export default component.exports